var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RenderImage',_vm._b({},'RenderImage',_vm.args,false))}
var staticRenderFns = []

export { render, staticRenderFns }